var config = {
    apiKey: "AIzaSyBXc1zeV82VjoVs62aMxPPOYyppxUZTSoo",
    authDomain: "wuoshi-raid-progression.firebaseapp.com", 
    databaseURL: "https://wuoshi-raid-progression-default-rtdb.firebaseio.com/",
    projectId: "wuoshi-raid-progression",
    storageBucket: "wuoshi-raid-progression.firebasestorage.app",
    messagingSenderId: "650097181280",
    appId: "1:650097181280:web:f91437d86a45f62d597905"
};

// Initialize Firebase before the Angular module is defined
if (!firebase.apps.length) {
    firebase.initializeApp(config);
}

var app = angular.module('app', ['firebase']).config(['$locationProvider', function ($locationProvider) {
    $locationProvider.html5Mode({
        enabled: false,
        rewriteLinks: false,
        requireBase: false
    });
}]);